import Application from '@ember/application';
import Ember from 'ember';
import Resolver from 'ember-resolver';
import loadInitializers from 'ember-load-initializers';
import $ from 'jquery';
import config from 'adcdriver/config/environment';
import { importSync, isDevelopingApp, macroCondition, isTesting } from '@embroider/macros';

if (macroCondition(isDevelopingApp())) {
    importSync('./deprecation-workflow');
}

// Math.log10 polyfill for IE
Math.log10 =
    Math.log10 ||
    function (x) {
        return Math.log(x) * Math.LOG10E;
    };

// Math.sign polyfill for IE
if (!Math.sign) {
    Math.sign = function (x) {
        // If x is NaN, the result is NaN.
        // If x is -0, the result is -0.
        // If x is +0, the result is +0.
        // If x is negative and not -0, the result is -1.
        // If x is positive and not +0, the result is +1.
        x = +x; // convert to a number
        if (x === 0 || isNaN(x)) {
            return Number(x);
        }
        return x > 0 ? 1 : -1;
    };
}

// String.prototype.includes polyfill for IE
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

// endsWith polyfill for IE
if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

$.fn.exists = function () {
    return this.length !== 0;
};
//#endregion polyfills

// const App = Application.extend({
// 	modulePrefix: config.modulePrefix,
// 	podModulePrefix: config.podModulePrefix,
// 	Resolver
// });
export default class App extends Application {
    modulePrefix = config.modulePrefix;
    podModulePrefix = config.podModulePrefix;
    Resolver = Resolver;
    customEvents = {
        mousedown: 'mouseDown',
    };
}

Ember.onerror = function (error) {
    if (macroCondition(isTesting())) {
        throw error;
    } else {
        console.error(error);
    }
};

loadInitializers(App, config.modulePrefix);
